import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { getActiveSite } from './configs/sites';
import { getPortfolioCopy } from './content/portfolioCopy';

const activeSite = getActiveSite();
const resources = getPortfolioCopy(activeSite.copyProfile);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,

    supportedLngs: activeSite.supportedLanguages,

    fallbackLng: activeSite.defaultLanguage,

    detection: {
      order: ['path'],
      lookupFromPathIndex: 0,
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
